const filterFunctions = {
  greaterThan: {
    id: 'greaterThan',
    func: x => userInput => {
      try {
        return userInput > x;
      } catch (error) {
        return false;
      }
    },
    symbol: '>',
    dataType: 'number'
  },
  greaterThanOrEquals: {
    id: 'greaterThanOrEquals',
    func: x => userInput => {
      try {
        return userInput >= x;
      } catch (error) {
        return false;
      }
    },
    symbol: '>=',
    dataType: 'number'
  },
  lessThan: {
    id: 'lessThan',
    func: x => userInput => {
      try {
        return userInput < x;
      } catch (error) {
        return false;
      }
    },
    symbol: '<',
    dataType: 'number'
  },
  lessThanOrEquals: {
    id: 'lessThanOrEquals',
    func: x => userInput => {
      try {
        return userInput <= x;
      } catch (error) {
        return false;
      }
    },
    symbol: '<=',
    dataType: 'number'
  },
  equals: {
    id: 'equals',
    func: x => userInput => {
      try {
        return userInput === x;
      } catch (error) {
        return false;
      }
    },
    symbol: '=',
    dataType: 'number'
  },
  notEquals: {
    id: 'notEquals',
    func: x => userInput => {
      try {
        return userInput !== x;
      } catch (error) {
        return true;
      }
    },
    symbol: 'not equals',
    dataType: 'number'
  },
  isExactly: {
    id: 'isExactly',
    func: x => userInput => {
      try {
        return userInput === x;
      } catch (error) {
        return false;
      }
    },
    symbol: 'equals',
    dataType: 'string'
  },
  contains: { // strip whitespace and ignore case
    id: 'contains',
    func: x => userInput => {
      try {
        const adjustedInput = userInput.replace(/ /g, '').toLowerCase();
        const adjustedX = x.replace(/ /g, '').toLowerCase();
        return adjustedInput.indexOf(adjustedX) !== -1;
      } catch (error) {
        return false;
      }
    },
    symbol: 'contains',
    dataType: 'string'
  },
  notContains: {
    id: 'notContains',
    func: x => userInput => {
      try {
        return userInput.indexOf(x) === -1;
      } catch (error) {
        return true;
      }
    },
    symbol: 'does not contain',
    dataType: 'string'
  },
  startsWith: {
    id: 'startsWith',
    func: x => userInput => {
      try {
        return userInput.indexOf(x) === 0;
      } catch (error) {
        return false;
      }
    },
    symbol: 'starts with',
    dataType: 'string'
  },
  includes: {
    id: 'includes',
    func: userInput => array => {
      try { // any item in the array contains the input string (ignoring case & whitespace)
        const adjustedInput = userInput.replace(/ /g, '').toLowerCase();
        for (let i = 0; i < array.length; i++) {
          const item = array[i].replace(/ /g, '').toLowerCase();
          if (item.indexOf(adjustedInput) !== -1) {
            return true;
          }
        }
        return false;
      } catch (error) {
        return false;
      }
    },
    symbol: 'includes',
    dataType: 'string-array'
  },
  notIncludes: {
    id: 'notIncludes',
    func: userInput => array => {
      try { // no item in the array contains the input string (ignore case)
        const adjustedInput = userInput.toLowerCase();
        for (let i = 0; i < array.length; i++) {
          const item = array[i].toLowerCase();
          if (item.indexOf(adjustedInput) !== -1) {
            return false;
          }
          // // eslint-disable-next-line max-len
          // console.log(`index of "${adjustedInput}" in "${item}" is ${item.indexOf(adjustedInput)}`);
        }
        return true;
      } catch (error) {
        return true;
      }
    },
    symbol: 'does not include',
    dataType: 'string-array'
  }
};

export const getInitialFilterType = dataType => {
  if (dataType === 'string') return 'contains';
  if (dataType === 'number') return 'greaterThan';
  return 'isExactly';
};

export const getFilterFunction = key => {
  return filterFunctions[key].func;
};

export default filterFunctions;
